import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "jsonToText",
  standalone: true,
})
export class JsonToTextPipe implements PipeTransform {
  transform(val: any) {
    return JSON.stringify(val, undefined, 4)
      .replace(/ /g, "&nbsp;")
      .replace(/\n/g, "<br/>");
  }
}
